"use client";

import React, { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const statsData = [];
function AnimatedStat({
  endValue,
  suffix,
  label,
  index
}: {
  endValue: number;
  suffix: string;
  label: string;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const duration = 2000;
      const increment = endValue / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= endValue) {
          setCount(endValue);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isVisible, endValue]);
  return <div data-section-id="95537" ref={ref} data-index={index} className="flex flex-1 flex-col items-center justify-center px-4 py-12 text-center lg:py-16">
      <div className="mb-3 font-default text-6xl font-bold !text-[hsl(0,0%,100%)] md:text-7xl lg:text-8xl">100%</div>
      <div className="font-default text-sm font-medium tracking-widest text-muted-foreground uppercase md:text-base">
        {label}
      </div>
    </div>;
}
export default function InNumbers() {
  return <section id="направления-работы" className="dark bg-background text-foreground w-full border-y border-border/10">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col divide-y divide-border/20 lg:flex-row lg:divide-x lg:divide-y-0">
          {statsData.map((stat, i) => <AnimatedStat key={i} index={i} endValue={stat.endValue} suffix={stat.suffix} label={stat.label} />)}
        </div>
      </div>
    </section>;
}